/* eslint-disable @typescript-eslint/no-explicit-any */
import { SharedAppConstants } from '@tock/shared-app-constants';
import { combineAndSortPastPurchases } from '@tock/shared/utils/patronUtils';
import { core, toJSON, toJSONArray } from '@tock/coretypes';

interface State {
  bookingHistory: core.PastPurchase[];
  cardsForPatron: core.PaymentCard[];
  expiredBookViaEmailsHistory: any[];
  isInitialized: boolean;
  purchaseHistory: any[];
  waitlistHistory: any[];
  checkHistory: any[];
  walkInHistory: any[];
  detectedLocation: core.DetectedLocation;
}

export const initialState: State = {
  bookingHistory: [],
  cardsForPatron: [],
  expiredBookViaEmailsHistory: [],
  isInitialized: false,
  purchaseHistory: [],
  waitlistHistory: [],
  checkHistory: [],
  walkInHistory: [],
  detectedLocation: {} as any,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload } = action;
  switch (type) {
    case SharedAppConstants.PATRON_CARDS_CLEAR: {
      return {
        ...state,
        cardsForPatron: [],
        isInitialized: true,
      };
    }
    case SharedAppConstants.PATRON_CARDS_FETCH_ALL_DONE: {
      return {
        ...state,
        cardsForPatron: toJSONArray<core.PaymentCard>(payload),
        isInitialized: true,
      };
    }
    case SharedAppConstants.PATRON_FETCH_PAY_BY_EMAILS_DONE: {
      return {
        ...state,
        isInitialized: true,
        expiredBookViaEmailsHistory: payload,
      };
    }
    case SharedAppConstants.PATRON_FETCH_PURCHASE_HISTORY_DONE: {
      const batchResponses = payload;
      return {
        ...state,
        isInitialized: true,
        purchaseHistory: combineAndSortPastPurchases(
          toJSONArray(batchResponses[0]),
          toJSONArray(batchResponses[1])
        ),
      };
    }
    case SharedAppConstants.PATRON_UPDATE_PURCHASE_HISTORY_PURCHASE: {
      const purchase = payload as core.IPastPurchase;
      const purchaseToUpdateIndex = state.purchaseHistory.findIndex((p) => p.id === purchase.id);

      if (purchaseToUpdateIndex === -1) {
        return state;
      }

      const purchaseToUpdate = state.purchaseHistory[purchaseToUpdateIndex];

      const purchaseHistory = [
        ...state.purchaseHistory.slice(0, purchaseToUpdateIndex),
        { ...purchaseToUpdate, ...purchase },
        ...state.purchaseHistory.slice(purchaseToUpdateIndex + 1),
      ];
      return {
        ...state,
        purchaseHistory,
      };
    }
    case SharedAppConstants.PATRON_FETCH_WAITLIST_DONE: {
      return {
        ...state,
        isInitialized: true,
        waitlistHistory: payload,
      };
    }
    case SharedAppConstants.PATRON_FETCH_CHECKS_DONE: {
      return {
        ...state,
        isInitialized: true,
        checkHistory: toJSONArray(payload),
      };
    }
    case SharedAppConstants.PATRON_FETCH_WALKINS_DONE: {
      return {
        ...state,
        isInitialized: true,
        walkInHistory: toJSONArray(payload),
      };
    }
    case SharedAppConstants.PATRON_CARDS_FETCH_ALL_STARTING:
    case SharedAppConstants.PATRON_FETCH_PAY_BY_EMAILS_STARTING:
    case SharedAppConstants.PATRON_FETCH_PURCHASE_HISTORY_STARTING:
    case SharedAppConstants.PATRON_FETCH_WAITLIST_STARTING:
    case SharedAppConstants.PATRON_FETCH_CHECKS_STARTING:
    case SharedAppConstants.PATRON_FETCH_WALKINS_STARTING:
      return {
        ...state,
        isInitialized: false,
      };
    case SharedAppConstants.PATRON_CARDS_FETCH_ALL_FAILED:
    case SharedAppConstants.PATRON_FETCH_PAY_BY_EMAILS_FAILED:
    case SharedAppConstants.PATRON_FETCH_PURCHASE_HISTORY_FAILED:
    case SharedAppConstants.PATRON_FETCH_WAITLIST_FAILED:
    case SharedAppConstants.PATRON_FETCH_CHECKS_FAILED:
    case SharedAppConstants.PATRON_FETCH_WALKINS_FAILED:
      return {
        ...state,
        isInitialized: true,
      };
    case SharedAppConstants.DETECT_LOCATION_DONE: {
      const detectedLocation = toJSON<core.DetectedLocation>(payload);

      return {
        ...state,
        detectedLocation,
      };
    }
    default:
      return state;
  }
}
